import axios from "axios"

function chooseTutor({ tutor_id }, data) {
    return axios.post(`/api/tutors/${tutor_id}/choose`, data)
}

function updateSlot(values) {
    return axios.put("/api/user/interview-slots", values)
}

function postNote({ id }, values) {
    return axios.post(`/api/v1/users/${id}/tutor-notes`, values)
}

function getNotes({ id }) {
    return axios.get(`/api/v1/users/${id}/tutor-notes`)
}

function updateNote({ id }, values) {
    return axios.put(`/api/v1/tutor-notes/${id}`, values)
}

function deleteNote({ id }) {
    return axios.delete(`/api/v1/tutor-notes/${id}`)
}

function submitPersonalInfos({}, data) {
    return axios.put(`/api/v1/personal-infos`, data)
}

function submitCompleteProfile({}, data) {
    return axios.put(`/api/v1/update-tutor-profile`, data)
}

function getTestQuestions({}, {}, params) {
    return axios.get(`/api/v1/test-questions`, { params })
}

function submitTestAnswer({}, data) {
    return axios.post(`/api/v1/app-questions/submit-answer`, data)
}

function submitTestAnswers({}, data) {
    return axios.post(`/api/v1/app-questions/submit-answers`, data)
}

function submitTestVideo({ id }, data) {
    return axios.post(`/api/v1/app-questions/${id}/submit-answer`, data)
}

function submitQuestionViewed({ id }) {
    return axios.post(`/api/v1/app-questions/${id}/submit-view`)
}

function getTutoringInvoices({}, {}, params) {
    return axios.get(`/api/v2/tutoring-invoices`, { params })
}

function generateFullPdf({ id }) {
    return axios.post(`/api/v2/tutoring-invoices/${id}/generate-full-pdf`)
}

function acceptTrials({ id }, data) {
    return axios.post(`/api/tutors/${id}/accept-trials`, data)
}

function getTutorLiveOccurrences({}, {}, params) {
    return axios.get(`api/v1/tutors/live-occurrences`, { params })
}

function getTutorScore({}, {}, params) {
    return axios.get(`/api/v1/tutor/score`, { params })
}

function getTutorTasks() {
    return axios.get(`/api/v1/tutor/tasks`)
}

export const tutorsService = {
    chooseTutor,
    updateSlot,
    postNote,
    getNotes,
    updateNote,
    deleteNote,
    submitPersonalInfos,
    getTestQuestions,
    submitTestAnswer,
    submitQuestionViewed,
    submitCompleteProfile,
    getTutoringInvoices,
    generateFullPdf,
    acceptTrials,
    getTutorLiveOccurrences,
    submitTestVideo,
    submitTestAnswers,
    getTutorScore,
    getTutorTasks,
}
